// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e519305b","710":"4c4c6755","804":"564aa72c"}[chunkId] + ".chunk.js";
};